import { css } from 'styled-jsx/css';
import breakPoints from 'helpers/Styles';

export default css`
  .pc-model-wrapper {
    color: white;
  }

  .pc-model-config-container {
    /* min-width: 1200px; */
    margin-top: 72px;
  }
  .sticky-container-desktop {
    margin-top: 176px;
  }

  .pc-model-config-options {
    /* padding: 0 48px 104px 48px; */
    display: flex;
    flex-direction: row;
    flex-grow: 1;
    align-items: flex-start;
    padding-bottom: 30px;
  }
  .pc-configurator {
    padding-top: 80px;
    margin-top: -80px;
  }
  @media (max-width: 1024px) {
    .pc-model-config-container {
      min-width: unset;
    }
    .pc-model-config-options {
      flex-direction: column;
    }

    .pc-model-config-options {
      padding: 0;
    }
  }
  @media (max-width: ${breakPoints.medium}) {
    .steps {
      display: none;
    }
    .pc-model-config-container {
      margin-top: 100px;
    }
    .sticky-container-tablet {
      margin-top: 212px;
    }
  }
  @media (max-width: ${breakPoints.mobileL}) {
    .pc-model-config-container {
      margin-top: 72px;
    }
    .sticky-container-mobile {
      margin-top: 160px;
    }
  }
`;

export const global = css.global`
  @media (max-width: 1024px) {
    .sticky-wrapper {
      width: 100%;
      z-index: 2;
    }
  }
`;
